class StayAISubscriptions extends HTMLElement {
  constructor() {
    super();
    this.productJSON = this.getAttribute("productData");
    this.product = JSON.parse(this.productJSON);
    this.initialVariant = this.getAttribute("currentVariantId");
    this.sellingPlanGroups = JSON.parse(this.getAttribute("sellingPlanGroups"));
    this.productFormId = this.getAttribute("productFormId");
    this.frequencyVisible = this.getAttribute("frequencyVisible");
  }
  connectedCallback() {
    this.initWidget();
    this.setupEventListeners();
  }
  initWidget() {
    this.removeRechargeWidgets()
    this.purchaseTypeSubscription = this.querySelector("[for='purchaseTypeSubscription']");
    this.purchaseTypeOneTime = this.querySelector("[for='purchaseTypeOneTime']");
    this.sellingPlanSelector = this.querySelectorAll(".stayai-frequency-option");
    this.sellingPlanFrequencies = this.querySelector(".stayai-frequency-selector")
    this.subscriptionBox = this.querySelector("[data-retextion-subscription-box]");
    this.subscriptionBoxContainer = this.querySelector(".stayai-subscription-frequency-container");
    this.radioOneTime = this.querySelector('input[value="purchaseTypeOneTime"]');
    this.radioSubscription = this.querySelector('input[value="purchaseTypeSubscription"]');
    const selectedInitialVariant = this.product.variants.find((variant) => variant.id === Number(this.initialVariant));
    this.currentVariant = selectedInitialVariant || this.product.variants[0];
    this.updateSellingPlans();
  }
  removeRechargeWidgets() {
    const interval = setInterval(() => {
      const rechargeWidget = document.querySelector('.rc-container-wrapper');
      document.querySelectorAll('script[src]').forEach(script => {
        if (script.src.includes('recharge')) script.remove();
      });

      if (rechargeWidget) {
        clearInterval(interval);
        rechargeWidget.remove()
        this.updateSellingPlans()
      }
    }, 500);

    setTimeout(() => clearInterval(interval), 10000);
  }
  // Set up event listeners for the purchase type, frequency and variant selectors
  setupEventListeners() {
    const purchaseTypeRadioButtons = this.querySelectorAll('input[name="purchaseType"]');
    // Handle purchase type change
    purchaseTypeRadioButtons.forEach((radio) =>
      radio.addEventListener("change", () => {
        this[radio.value === "purchaseTypeSubscription" ? "showSubscriptionBox" : "hideSubscriptionBox"]();
        const selectedValue = this.querySelector("[name='stayai_selling_plan']:checked")
        this.updateProductPrice(selectedValue.value);
      }),
    );
    
    // Handle variant change from URL
    window.addEventListener("popstate", this.updateVariantID());
    this.observeUrlChanges();
    // Handle browser back/forward navigation
    window.addEventListener("pageshow", (event) => {
      if (event.persisted || performance.getEntriesByType("navigation")[0]?.type === "back_forward") {
        this.isSubscriptionOptionSelected()
          ? this.querySelector("label[for='purchaseTypeSubscription']").click()
          : this.querySelector("label[for='purchaseTypeOneTime']").click();
        this.updateSellingPlans();
      }
    });

    this.setOptionEventListener()
  }
  setOptionEventListener() {
    const sellingPlanOptions = this.querySelectorAll('[name="stayai_selling_plan"');
    sellingPlanOptions.forEach((sel) => {
      sel.addEventListener("change", (e) => {
        this.updateSellingPlanInput(e.target.value);
        this.updateProductPrice(e.target.value);
      });
    })
  }
  // Get variant ID from the URL and update the variant
  updateVariantID = () => {
    const urlParams = new URLSearchParams(window.location.search);
    const variantId = Number(urlParams.get("variant"));
    if (!urlParams.has("variant")) return;
    if (variantId && variantId !== this.currentVariant.id) {
      this.currentVariant = this.product.variants.find((v) => v.id === variantId);
      this.updateSellingPlans();
    }
  };
  // Monitor URL changes without overriding history methods
  observeUrlChanges = () => {
    let lastUrl = window.location.href;
    new MutationObserver(() => {
      if (window.location.href !== lastUrl) {
        lastUrl = window.location.href;
        this.updateVariantID();
      }
    }).observe(document, { subtree: true, childList: true });
  };
  // Populate the subscription frequency selector with selling plans for the current variant
  updateSellingPlans() {
    const stayWidget = this.querySelector(`.stayai-subscriptions`);
    if (!stayWidget) return;
    // Filter out bundle-type selling plan groups and map them by ID
    const groupMap = new Map(
      this.sellingPlanGroups.filter((g) => !g.options[0].name.toLowerCase().includes("bundle")).map((g) => [g.id, g]),
    );
    const sellingPlans = this.currentVariant.selling_plan_allocations
      .map((spa) => groupMap.get(spa.selling_plan_group_id)?.selling_plans.find((sp) => sp.id === spa.selling_plan_id))
      .filter(Boolean);
    
    if (sellingPlans.length === 0) {
      this.updateSellingPlanInput("");
      stayWidget.classList.toggle("is-visible", false);
      console.log("No SPs, hiding widget");
      return;
    } else stayWidget.classList.toggle("is-visible", true);

    this.sellingPlanFrequencies.innerHTML = sellingPlans
      .map((plan, i) => `
        <div class="stayai-frequency-option">
          <input type="radio" name="stayai_selling_plan" id="stay-freq-${i}" value="${plan.id}" ${i === 0 ? ' checked' : ''}>
          <label for="stay-freq-${i}">${plan.options[0].value}
            <div class="stayai-frequency__savings">save ${plan.price_adjustments[0].value_type === 'percentage' ? this.appendPercent(plan.price_adjustments[0].value) : this.formatMoney(plan.price_adjustments[0].value)}</div>
          </label>
        </div>`)
      .join("")
    
    this.updateSellingPlanInput(this.isSubscriptionOptionSelected() ? sellingPlans[0]?.id || "" : "")

    // Show or hide the subscription frequency selector
    this.subscriptionBox.classList.toggle("is-visible", this.isSubscriptionOptionSelected());
    if (this.subscriptionBoxContainer)
      this.subscriptionBoxContainer.classList.toggle("subscriptionBoxContainer", this.isSubscriptionOptionSelected());
    // Update prices
    const selectedValue = this.querySelector("[name='stayai_selling_plan']:checked")
    this.updateProductPrice(
      this.isSubscriptionOptionSelected() ? selectedValue.value : sellingPlans[0]?.id || "",
    );

    this.setOptionEventListener()
  }

  appendPercent(price) {
    return `${price}%`
  }
  // Show the subscription frequency selector
  showSubscriptionBox() {
    this.subscriptionBox.classList.toggle("stayai-disable", false);
    this.subscriptionBox.classList.toggle("is-visible", true);
    if (this.subscriptionBoxContainer) this.subscriptionBoxContainer.classList.toggle("subscriptionBoxContainer", true);
    this.purchaseTypeSubscription.classList.toggle("is-selected", true);
    this.purchaseTypeOneTime.classList.toggle("is-selected", false);
    const selectedEl = this.querySelector("[name='stayai_selling_plan']:checked")
    this.updateSellingPlanInput(selectedEl.value);
  }
  // Hide the subscription frequency selector
  hideSubscriptionBox() {
    if (this.subscriptionBoxContainer) this.subscriptionBoxContainer.classList.toggle("is-visible", false);
    this.subscriptionBox.classList.toggle("is-visible", false);
    this.subscriptionBox.classList.toggle("disable", true);
    this.purchaseTypeSubscription.classList.toggle("is-selected", false);
    this.purchaseTypeOneTime.classList.toggle("is-selected", true);
    this.updateSellingPlanInput("");
  }
  // Check if the subscription option is selected
  isSubscriptionOptionSelected() {
    return this.purchaseTypeSubscription.classList.contains("is-selected");
  }
  //Add selling plan input to form with specified selling plan ID
  updateSellingPlanInput(sellingPlanId) {
    let productForm = document.querySelector(`#${this.productFormId}`)
    if (!productForm) return;
    // Find or create the hidden input for selling plan
    let sellingPlanInput = productForm.querySelector("input[name='selling_plan']");

    if (!sellingPlanInput) {
      sellingPlanInput = document.createElement("input");
      sellingPlanInput.type = "hidden";
      sellingPlanInput.name = "selling_plan";
      sellingPlanInput.value = sellingPlanId;
      productForm.appendChild(sellingPlanInput);
    }
    setTimeout(() => {
      sellingPlanInput.value = sellingPlanId;
    }, 500);

    // Dispatch event with the selling plan value
    this.fireStayAiEvent("stay-ai-subscription-changed", sellingPlanId);
  }
  updateProductPrice(sellingPlanId) {
    const selectedSellingPlanAllocation = this.currentVariant.selling_plan_allocations.find(
      (spa) => spa.selling_plan_id == sellingPlanId,
    );
    const sellingPlan = this.sellingPlanGroups
      .find((group) => group.selling_plans.some((sp) => sp.id == sellingPlanId))
      ?.selling_plans.find((sp) => sp.id == sellingPlanId);
    const oneTimeLblPrice = this.querySelector("[data-stayai-onetime-price]");
    const subscriptionLblPrice = this.querySelector("[data-stayai-subscription-price]");
    const savingLbl = this.querySelector(".subscription-savings");
    const onetimePrice = this.formatMoney(this.currentVariant.price);
    const compareAtPrice = this.formatMoney(this.currentVariant.compare_at_price);
    let subscriptionPrice = onetimePrice;

    // Update one-time price
    if (oneTimeLblPrice && oneTimeLblPrice.textContent !== onetimePrice) {
      //Update compare at price
      oneTimeLblPrice.innerHTML =
        compareAtPrice !== "$0.00" && compareAtPrice !== onetimePrice
          ? `<s>${compareAtPrice}</s> ${onetimePrice}`
          : onetimePrice;
    }

    // Update subscription price
    if (selectedSellingPlanAllocation) {
      subscriptionPrice = this.formatMoney(selectedSellingPlanAllocation.price);
      if (subscriptionLblPrice && subscriptionPrice !== subscriptionLblPrice.textContent) {
        subscriptionLblPrice.innerHTML =
          subscriptionPrice !== onetimePrice
            ? `<s class="fullPrice">${onetimePrice}</s>${subscriptionPrice}`
            : subscriptionPrice;
      }
      // Calculate and update savings label
      let discount = this.currentVariant.price - selectedSellingPlanAllocation.price;
      if (discount > 0) {
        if (sellingPlan?.price_adjustments[0].value_type === "percentage") {
          discount = `${sellingPlan.price_adjustments[0].value}%`;
        } else {
          discount = this.formatMoney(discount);
        }
        if (savingLbl.textContent !== discount) savingLbl.textContent = discount;
      } else {
        savingLbl.textContent = "";
      }
    }
  }
  // Toggle checked state based on the currently checked radio button
  toggleRadioButtons() {
    this.radioOneTime.checked = !this.radioOneTime.checked;
    this.radioSubscription.checked = !this.radioSubscription.checked;
  }
  // Format money based on Shopify's active currency
  formatMoney(money) {
    const { Shopify, theme } = window;
    const currency = Shopify?.currency?.active || "USD";
    const locale = Shopify?.locale || "en";
    const hasShopifyFormatMoney = Shopify && typeof Shopify?.formatMoney === "function";
    const hasThemeUtilsFormatMoney = theme?.utils && typeof theme?.utils?.formatMoney === "function";
    const formattedMoney = (money / 100).toFixed(2);
    let formatted;
    const currencyFormatter = new Intl.NumberFormat(locale, {
      currency,
      style: "currency",
    });
    if (!hasShopifyFormatMoney && !hasThemeUtilsFormatMoney) {
      return currencyFormatter.format(Number(formattedMoney));
    }
    formatted = hasShopifyFormatMoney ? Shopify.formatMoney(money) : theme.utils.formatMoney(money);
    return formatted || currencyFormatter.format(Number(formattedMoney));
  }
  fireStayAiEvent(eventName, sellingPlanId) {
    const event = new CustomEvent(eventName, {
      detail: {
        sellingPlanId: sellingPlanId,
      },
    });
    window.dispatchEvent(event);
  }
}
// Define the custom element
customElements.define("purchase-options", StayAISubscriptions);